import { LegalLayout } from "@/components/LegalLayout";

const H = ({ children }) => (
  <h2 className="font-condensed text-lg font-semibold uppercase tracking-wide text-ink">{children}</h2>
);

const Privacy = () => (
  <LegalLayout title="Privacy Policy" testId="privacy-page">
    <p>Last updated: 2026. This policy explains what information ALIGNMENT ("we", "us") collects when you visit this page or purchase the product, and how it's used.</p>

    <div>
      <H>What we collect</H>
      <p className="mt-2">When you purchase, payment is processed securely by Stripe. We receive your name and email address from Stripe so we can deliver your digital product. We never see or store your card details.</p>
    </div>

    <div>
      <H>How it's used</H>
      <p className="mt-2">Your email is used to deliver ALIGNMENT, send product updates, and — only if you've opted in — occasional emails from Dasha Love. You can unsubscribe at any time.</p>
    </div>

    <div>
      <H>Analytics & cookies</H>
      <p className="mt-2">This page may use basic, privacy-respecting analytics to understand visitor traffic. No personal information is sold or shared with third parties for marketing.</p>
    </div>

    <div>
      <H>Your rights</H>
      <p className="mt-2">You can request a copy of your data or ask for it to be deleted at any time by contacting us at the email address below.</p>
    </div>

    <div>
      <H>Contact</H>
      <p className="mt-2">Questions about this policy: reach out via the contact email provided on your purchase receipt.</p>
    </div>
  </LegalLayout>
);

export default Privacy;
